import TestDataGenerator from './test-data-generator';
import AnalyticsReports from './reports';

class Analytics {

  constructor(basePath, apiClient) {

    this.basePath = `${basePath}/analytics`;
    this.apiClient = apiClient;
    this.dataGenerator = new TestDataGenerator();
    this.reports = new AnalyticsReports(this.basePath, this.apiClient);

  }

  async bootstrap() {

    const path = `${this.basePath}/bootstrap`;

    return this.apiClient.get(path, {}, {}, {});

  }

  async getDashboardCards(intervalInDays) {

    const path = `${this.basePath}/dashboard/cards/:intervalInDays`;

    return this.apiClient.get(path, { intervalInDays }, {}, {});

  }

  async getTotalViewsByQueryOptions(filterOptions, groupOptions) {

    const path = `${this.basePath}/total-views`;

    return this.apiClient.post(path, {}, {}, { filterOptions, groupOptions });

  }

  async getUniqueUsersByQueryOptions(filterOptions, groupOptions) {

    const path = `${this.basePath}/unique-users`;

    return this.apiClient.post(path, {}, {}, { filterOptions, groupOptions });

  }

  async getRegisteredUsersByQueryOptions(filterOptions, groupOptions) {

    const path = `${this.basePath}/registered-users`;

    return this.apiClient.post(path, {}, {}, { filterOptions, groupOptions });

  }

  async getEngagementCountByQueryOptions(filterOptions, groupOptions) {

    const path = `${this.basePath}/engagement`;

    return this.apiClient.post(path, {}, {}, { filterOptions, groupOptions });

  }

  async getAnnotationsByQueryOptions(filterOptions, groupOptions) {

    const path = `${this.basePath}/annotations`;

    return this.apiClient.post(path, {}, {}, { filterOptions, groupOptions });

  }

  async getUserVerticalValuesByColumn(column, type, startDate, endDate) {

    const path = `${this.basePath}/events/values/:column/:type/:startDate/:endDate`;

    return this.apiClient.get(path, { column, type, startDate, endDate }, {});

  }

  async getUserPropertyNames() {

    const path = `${this.basePath}/user-property-names`;

    return this.apiClient.get(path, {}, {});

    // return this.dataGenerator.generateUserPropertyNames();

  }

  async getUserPropertyValuesByName(propertyName) {

    const path = `${this.basePath}/user-property-names/:propertyName/values`;

    return this.apiClient.get(path, { propertyName }, {});

    // return this.dataGenerator.generateUserPropertyNameValues(propertyName);

  }

  async getUserPropertyValuesByNameAndValue(propertyName, searchTerm) {

    const path = `${this.basePath}/user-property-names/:propertyName/values`;

    return this.apiClient.get(path, { propertyName }, { filterOptions: { searchTerm } });

    // return this.dataGenerator.generateUserPropertyNameValues(propertyName);

  }

  async createPageEventDefinition(definition) {

    const path = `${this.basePath}/page-event-definitions`;

    return this.apiClient.post(path, {}, {}, definition);

  }

  async getPageEventDefinitions(definition) {

    const path = `${this.basePath}/page-event-definitions`;

    return this.apiClient.get(path, {}, {}, definition);

  }

  async getPageEventDefinitionFieldValuesById(pageEventDefinitionId, payload) {

    const path = `${this.basePath}/page-event-definitions/:pageEventDefinitionId/field-values`;

    return this.apiClient.post(path, { pageEventDefinitionId }, {}, payload);

  }

  async hidePageEventDefinition(pageEventDefinitionId, hidden) {

    const path = `${this.basePath}/page-event-definitions/:pageEventDefinitionId/hidden`;

    return this.apiClient.put(path, { pageEventDefinitionId }, {}, { hidden });

  }

  async deletePageEventDefinition(pageEventDefinitionId) {

    const path = `${this.basePath}/page-event-definitions/:pageEventDefinitionId`;

    return this.apiClient.delete(path, { pageEventDefinitionId }, {});

  }

  async countDefinedPageEventEntriesByIdAndQueryOptions(pageEventDefinitionId, payload) {

    const path = `${this.basePath}/counts/:pageEventDefinitionId`;

    return this.apiClient.post(path, {
      pageEventDefinitionId
    }, {}, payload);

  }

  async getAnalyticsPITData(pageEventDefinitionId, payload) {

    const path = `${this.basePath}/point-in-time/:pageEventDefinitionId`;

    return this.apiClient.post(path, {
      pageEventDefinitionId
    }, {}, payload);

  }

}

export default Analytics;
